import React from 'react';
import { Instagram, Phone } from 'lucide-react';
const WHATSAPP_LINK = 'https://wa.me/573054520211?text=Hola%20vengo%20desde%20la%20web%20y%20quiero%20reservar%20una%20cita';
export function Footer() {
  return <footer className="bg-[#080808] py-12 border-t border-brand-dark" data-id="element-34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <div className="flex flex-col items-center text-center space-y-8" data-id="element-36">
          <img src="https://cdn.magicpatterns.com/uploads/qNMs9QRv4uc9izQxfDfbUw/image.png" alt="Le Barber Club Logo" className="h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity" data-id="element-37" />

          <div className="text-brand-gray text-sm space-y-2" data-id="element-38">
            <p data-id="element-39">Cl. 75 Sur #45-82 LOCAL 0201, Sabaneta, Antioquia</p>
            <p data-id="element-40">+57 305 4520211</p>
          </div>

          <div className="flex space-x-6" data-id="element-41">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-brand-gray hover:text-brand-gold transition-colors" data-id="element-42">
              <Instagram className="w-6 h-6" data-id="element-43" />
            </a>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="text-brand-gray hover:text-brand-gold transition-colors" data-id="element-44">
              <Phone className="w-6 h-6" data-id="element-45" />
            </a>
          </div>

          <div className="pt-8 border-t border-brand-dark w-full max-w-md" data-id="element-46">
            <p className="text-brand-gray text-xs mb-2" data-id="element-47">
              © {new Date().getFullYear()} Le Barber Club. Todos los derechos
              reservados.
            </p>
            <p className="text-brand-gray/50 text-xs" data-id="element-48">
              Hecho con ❤️ en Sabaneta
            </p>
          </div>
        </div>
      </div>
    </footer>;
}